// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TaZ2","index":"styles_index__Nfu2R"};